// extracted by mini-css-extract-plugin
export default {"sendForm":"MessageSender_sendForm__NuQvi","textarea":"MessageSender_textarea__bwuDr","button":"MessageSender_button__LSgf3"};